import { useState } from 'react'

const API_BASE = import.meta.env.VITE_API_BASE_URL || '/api'
const BRAND_COLOR = import.meta.env.VITE_BRAND_PRIMARY_COLOR || '#16a34a'

export default function VerifyPage() {
  const [email, setEmail] = useState('')
  const [otp, setOtp] = useState('')
  const [status, setStatus] = useState<string>('')

  async function requestCode() {
    setStatus('Sende...')
    try {
      const res = await fetch(`${API_BASE}/auth/verify-request`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      })
      const json = await res.json()
      setStatus(json.ok ? 'Code gesendet' : (json.error || 'Fehler'))
    } catch (e) {
      setStatus('Fehler beim Senden')
    }
  }

  async function confirmCode() {
    setStatus('Prüfe...')
    try {
      const res = await fetch(`${API_BASE}/auth/verify-confirm`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, otp })
      })
      const json = await res.json()
      setStatus(json.ok ? 'E-Mail verifiziert' : (json.error || 'Fehler'))
    } catch (e) {
      setStatus('Fehler bei der Bestätigung')
    }
  }

  return (
    <div style={{ fontFamily: 'Inter, Arial, sans-serif', maxWidth: 520, margin: '40px auto', padding: '0 16px' }}>
      <h1 style={{ fontSize: 22 }}>E-Mail bestätigen</h1>
      <p>Gib deine E-Mail und den 4-stelligen Code ein.</p>
      <label>E-Mail</label>
      <input value={email} onChange={e => setEmail(e.target.value)} type="email" placeholder="you@example.com" style={{ width: '100%', margin: '8px 0 16px', padding: '10px 12px', fontSize: 16 }} />
      <label>Code</label>
      <input value={otp} onChange={e => setOtp(e.target.value)} type="text" maxLength={4} placeholder="1234" style={{ width: '100%', margin: '8px 0 16px', padding: '10px 12px', fontSize: 16 }} />
      <div style={{ display: 'flex', gap: 10 }}>
        <button onClick={requestCode} style={{ background: BRAND_COLOR, color: '#fff', border: 0, borderRadius: 8, cursor: 'pointer', padding: '10px 12px', fontSize: 16 }}>Code anfordern</button>
        <button onClick={confirmCode} style={{ background: BRAND_COLOR, color: '#fff', border: 0, borderRadius: 8, cursor: 'pointer', padding: '10px 12px', fontSize: 16 }}>Bestätigen</button>
      </div>
      <p>{status}</p>
    </div>
  )
}